import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Collapse } from 'react-bootstrap';
import Arrow from '../Arrow/Arrow';
import './SupportArticle.scss';

const SupportArticle = (props) => {
  const { question, answer, shouldShow, link, id } = props;

  return (
    <div className="support-article" id={id}>
      <Link to={link}>
        <div className="article-arrow">
          <Arrow shouldRotate={shouldShow} />
        </div>
        <h4 className="article-heading">{question}</h4>
      </Link>
      <Collapse in={shouldShow}>
        <div id={`support-description-${id}`}>
          {
            // eslint-disable-next-line
            <p className="article-description" dangerouslySetInnerHTML={{ __html: answer }} />
          }
        </div>
      </Collapse>
    </div>
  );
};

SupportArticle.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string,
  shouldShow: PropTypes.bool,
  link: PropTypes.string,
  id: PropTypes.string
};

export default SupportArticle;



/** WEBPACK FOOTER **
 ** ./src/components/Support/SupportArticle.js
 **/